define([
    'jquery',
], function ($) {
    'use strict';

    const common = require('./common');

    const init = function() {
        $(function () {
            common.init();
        });
    };

    return {
        init: init
    };
});
